import { render, staticRenderFns } from "./ManageHeaders.vue?vue&type=template&id=60dac643"
import script from "./ManageHeaders.vue?vue&type=script&lang=js"
export * from "./ManageHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports